import { createFileRoute, Outlet } from '@tanstack/react-router';
import { AdminsPage } from '@/pages/admins';
import { commonSearchSchema } from '@/routes/-shared/commonSearchSchema';
import { requireSuperadmin } from '@/routes/-shared/require-superadmin';

/**
 * Solo i SUPERADMIN gestiscono gli accessi: il controllo sta sul layout, così
 * vale anche per le rotte figlie (`new`, `edit/$id`) aperte da un link.
 */
export const Route = createFileRoute('/admin/_layout/admins/_layout')({
  beforeLoad: requireSuperadmin,
  component: AdminsLayout,
  validateSearch: commonSearchSchema,
});

function AdminsLayout() {
  return (
    <>
      <AdminsPage />
      <Outlet />
    </>
  );
}
